// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import backlogItemEntity from './entities/backlog-item.json';
import backlogItemMenu from '../pages/backlog-item/menu.json';
import backlogItemFullForm from '../pages/backlog-item/forms/full.json';
import backlogItemContextForm from '../pages/backlog-item/forms/context.json';
import backlogItemMiniForm from '../pages/backlog-item/forms/mini.json';
import backlogItemLookupForm from '../pages/backlog-item/forms/lookup.json';
import backlogItemTableView from '../pages/backlog-item/views/table.json';
import backlogItemCardsView from '../pages/backlog-item/views/cards.json';
import backlogItemDashboardView from '../pages/backlog-item/views/dashboard.json';

/** Тип запису «Елемент беклогу» зі сторінками пакета: меню, форми та подання з pages/backlog-item/. */
export const backlogItemDefinition: IRecordTypeDefinition = {
  ...backlogItemEntity,
  views: assembleViewSet({
      table: backlogItemTableView,
      cards: backlogItemCardsView,
      dashboard: backlogItemDashboardView,
  }),
  form: backlogItemFullForm,
  forms: { full: backlogItemFullForm, context: backlogItemContextForm, mini: backlogItemMiniForm, lookup: backlogItemLookupForm },
  menu: backlogItemMenu,
} as IRecordTypeDefinition;
